import { Input } from './Input';
import { renderInput } from './renderInput';

export {
  Input,
  renderInput
}
